import React from 'react';

const Thumbnail = () => (
  <div className="w-full h-20 rounded-lg bg-zinc-100 dark:bg-zinc-800 p-2 flex items-center justify-center">
    <div className="w-full h-px bg-zinc-300 dark:bg-zinc-600" />
  </div>
);

export default Thumbnail;
